import { render, staticRenderFns } from "./createCommission.vue?vue&type=template&id=595596fd&scoped=true"
import script from "./createCommission.vue?vue&type=script&lang=js"
export * from "./createCommission.vue?vue&type=script&lang=js"
import style0 from "./createCommission.vue?vue&type=style&index=0&id=595596fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595596fd",
  null
  
)

export default component.exports